import React from 'react';

const Footer = props => {

  return (
    <div style={styles.loginFooterStyle}>
      <p style={{ ...styles.footerTextStyle, marginLeft: 10 }}>&copy; {new Date().getFullYear()}, Dividia Technologies, LLC </p>
      <p style={{ ...styles.footerTextStyle, marginRight: 10 }}>v. {process.env.REACT_APP_VERSION}</p>
    </div>
  )
}

export default Footer;

const styles = {
  loginFooterStyle: {
    width: '100%', 
    height: 30, 
    borderBottomRightRadius: 5, 
    borderBottomLeftRadius: 5, 
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  footerTextStyle: {
    fontSize: '1.2vmin',
    color: 'grey',
    fontWeight: 'bold'
  }
};
